import React from "react";
import "./Order_Overview_summery_holder.css";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";

function Order_Overview_summery_holder({ data, address, paymentValue }) {
  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const symbol = currentCurrency?.symbol || "₹";

  const summary = data?.order_summary;
  const money = (value) => `${symbol} ${Number(value || 0).toFixed(2)}`;

  const paymentLabel =
    paymentValue === 2 ? "Online" : paymentValue === 3 ? "Wallet" : "COD";

  const deliveryCharges = Number(summary?.total_delivery_charges || 0);

  const fullAddress = [
    address?.building,
    address?.street,
    address?.city_id?.label,
    address?.state_id?.label,
    address?.pincode_id?.label,
    address?.country_id?.label,
  ]
    .filter(Boolean)
    .join(", ");

  const rows = [
    { label: "Subtotal", value: money(summary?.total_selling_price) },
    {
      label: "Coupon discount",
      value: `- ${money(summary?.total_coupon_discount)}`,
      saving: true,
    },
    {
      label: "Offer discount",
      value: `- ${money(summary?.total_offer_discount)}`,
      saving: true,
    },
    { label: "Tax", value: money(summary?.total_tax) },
    {
      label: "Shipping",
      value: deliveryCharges === 0 ? "Free" : money(deliveryCharges),
      saving: deliveryCharges === 0,
    },
    { label: "Payment method", value: paymentLabel },
  ];

  return (
    <section className="Order_Overview_summery_holder">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <span className="summary_title">Order summary</span>
            <span className="summary_total">
              {money(summary?.total_amount)}
            </span>
          </Accordion.Header>

          <Accordion.Body>
            <dl className="summary_list">
              {rows.map((row) => (
                <div className="summary_row" key={row.label}>
                  <dt>{row.label}</dt>
                  <dd className={row.saving ? "is_saving" : ""}>{row.value}</dd>
                </div>
              ))}
            </dl>

            {fullAddress && (
              <div className="summary_address">
                <span className="summary_address_label">Delivery address</span>
                <p>{fullAddress}</p>
              </div>
            )}

            <div className="summary_grand_total">
              <span>Total amount</span>
              <strong>{money(summary?.total_amount)}</strong>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </section>
  );
}

export default Order_Overview_summery_holder;
